import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'giftcards.title',
    defaultMessage: 'Gift Cards',
  },
  fullTitle: {
    id: 'giftcards.seotitle',
    defaultMessage: 'Gift Cards',
  },
  all: {
    id: 'giftcards.all',
    defaultMessage: 'All Gift Cards',
  },
  desc: {
    id: 'giftcards.seodesc',
    defaultMessage: 'Purchase Gift Cards for other platforms from here! Get Nintendo eShop cards to buy Nintendo titles (including the fan-favourite The Legend of Zelda: Tears of the Kingdom), Microsoft Xbox, Roblox, and even PlayStation cards to buy your games! Pick your value, claim on the relevant platform, and purchase your games!',
  },
  seoBlurb: {
    id: 'giftcards.seoBlurb',
    defaultMessage: 'Purchase Gift Cards for other platforms from here! Get Nintendo eShop cards to buy Nintendo titles (including the fan-favourite The Legend of Zelda: Tears of the Kingdom), Microsoft Xbox, Roblox, and even PlayStation cards to buy your games! Pick your value, claim on the relevant platform, and purchase your games!',
  },
  topSellers: {
    id: 'giftcards.sort.top-sellers',
    defaultMessage: 'Top Sellers',
  },
  topDiscount: {
    id: 'giftcards.sort.top-discount',
    defaultMessage: 'Top Discount',
  },
  name: {
    id: 'giftcards.sort.name',
    defaultMessage: 'Alphabetical',
  },
  pricelowtohigh: {
    id: 'giftcards.sort.price-low-high',
    defaultMessage: 'Price: Low to High',
  },
  pricehightolow: {
    id: 'giftcards.sort.price-high-low',
    defaultMessage: 'Price: High to Low',
  },
  eaplayTitle: {
    id: 'giftcards.sort.ea-play-title',
    defaultMessage: 'EA Play Gift Cards',
  },
  eaplaySeoBlurb: {
    id: 'giftcards.seoBlurb',
    defaultMessage: 'Purchase Gift Cards for other platforms from here! Get Nintendo eShop cards to buy Nintendo titles (including the fan-favourite The Legend of Zelda: Tears of the Kingdom), Microsoft Xbox, Roblox, and even PlayStation cards to buy your games! Pick your value, claim on the relevant platform, and purchase your games!',
  },
  switchTitle: {
    id: 'giftcards.sort.nintendo-title',
    defaultMessage: 'Nintendo Gift Cards',
  },
  switchSeoBlurb: {
    id: 'giftcards.sort.nintendo-seoblurb',
    defaultMessage: 'Purchase Nintendo Gift Cards to take the opportunity to use them in Nintendo’s eShop! Buy famous Nintendo-owned franchises, from The Legend of Zelda, Mario, and even Pokémon for your Nintendo Switch!',
  },
  playstationTitle: {
    id: 'giftcards.sort.playstation-title',
    defaultMessage: 'PlayStation Gift Cards',
  },
  playstationSeoBlurb: {
    id: 'giftcards.sort.playstation-seoblurb',
    defaultMessage: 'From PlayStation 4 to PlayStation 5, get all the Gift Cards necessary to get some of PlayStation’s prestigious titles! Purchase titles like God of War Ragnarök, Horizon Forbidden West, or even Spider-Man 2 with these gift cards!',
  },
  robloxTitle: {
    id: 'giftcards.sort.roblox-title',
    defaultMessage: 'Roblox Gift Cards',
  },
  robloxSeoBlurb: {
    id: 'giftcards.sort.roblox-seoblurb',
    defaultMessage: 'Robox Gift Cards are a quick and easy way to add credits to your account or even get a premium subscription. Whether you want to use it to give someone a nice gift or for yourself, you\'ll also get two virtual items upon redemption as a bonus!',
  },
  xboxTitle: {
    id: 'giftcards.sort.xbox-title',
    defaultMessage: 'Xbox Gift Cards',
  },
  xboxSeoBlurb: {
    id: 'giftcards.sort.xbox-seoblurb',
    defaultMessage: 'Xbox Gift Cards are a phenomenal way to easily purchase — or gift! — anything from games and add-ons to map packs and more! It’s easy to redeem and can be used at the Microsoft Store online, on Windows, and Xbox. If you don’t know which games to get, you can even use it to get a month for the Xbox Game Pass for access to all sorts of titles!',
  },
  razerTitle: {
    id: 'giftcards.sort.razer-title',
    defaultMessage: 'Razer Gold Gift Cards',
  },
  razerSeoBlurb: {
    id: 'giftcards.sort.razer-seoblurb',
    defaultMessage: 'The Razer Gift Card unlocks the ultimate gifts for any gamer. From gaming peripherals to laptops to apparel, redeem from the largest catalog of Razer gear in the world, including rare and exclusive products only found on Razer.com.',
  },
});

export default messages;
